export default class Address {
  constructor(
  addressType,
  address,
  idInDB
  ) {
    this.addressType = addressType;
    this.address = address;
    this.idInDB = idInDB;
  }

  static createFromData(data) {
    let addresses = [];
    if (data.length !== 0) {
      for (let i = 0; i < data.length; i++) {
        let address = new Address(
          data[i].addressType,
          data[i].address,
          data[i].idInDB
        );
        addresses.push(address);
      }
    }

    return addresses;
  }

  static createNew(addressType) {
    return new Address(addressType, '', '');
  }
}
